<template>
  <v-container class="px-8">
    <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="d-flex flex-row justify-space-between align-end">
        <div class="text-h4 font-weight-medium">
          {{ $t("navbar.menu.subgroups") }}
        </div>
        <SubgroupInfo :key="dialogKey" @closed="dialogKey++" />
      </div>
    </div>
    <v-card>
      <v-card-text>
        <v-row class="mx-6">
          <v-col cols="1">{{ $t("company.tabs.branding.color") }}</v-col>
          <v-col cols="3">{{ $t("common.name") }}</v-col>
          <v-col cols="5">{{ $t("common.description") }}</v-col>
          <v-col cols="1" class="text-center">{{ $t("navbar.menu.chat") }}</v-col>
          <v-col cols="1" class="text-center">Expand</v-col>
          <v-col cols="1" class="text-center">Options</v-col>
        </v-row>
        <!-- <v-divider class="my-3"></v-divider> -->

        <v-expansion-panels
          v-if="subgroups.length > 0"
          v-model="panel"
          class="mt-2"
          :readonly="readonly"
          multiple
        >
          <v-expansion-panel v-for="(subgroup, index) in subgroups" :key="subgroup.id">
            <v-expansion-panel-header class="py-2">
              <v-row class="" no-gutters>
                <v-col cols="1" class="my-auto">
                  <div
                    :style="`width:24px;height:24px;border-radius:13px;
                    background-color:${subgroup.color};`"
                  ></div>
                </v-col>
                <v-col cols="3" class="my-auto">{{ subgroup.name }}</v-col>
                <v-col cols="5" class="my-auto">{{ subgroup.description }}</v-col>
                <v-col cols="1" class="text-center">
                  <v-icon v-if="subgroup.chat">mdi-check</v-icon>
                </v-col>
                <v-col cols="1" class="text-center">
                  <v-btn icon @click="panelClicked(index)"><v-icon>$expand</v-icon></v-btn>
                </v-col>
                <v-col cols="1" class="text-center">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn text icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="editSubgroupId = subgroup.id">
                        {{ $t("common.edit") }}
                      </v-list-item>
                      <v-list-item @click="deleteSubgroupId = subgroup.id">
                        {{ $t("common.delete") }}</v-list-item
                      >
                      <v-list-item
                        v-if="$store.state.trip.chats[subgroup.id]"
                        :to="{
                          name: 'chat',
                          params: { chatId: subgroup.id },
                        }"
                      >
                        {{ $t("navbar.menu.chat") }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <template v-slot:actions>
                <div></div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex flex-wrap">
                <v-chip
                  pill
                  v-for="userId in Object.keys(subgroup.user_ids)"
                  class="ma-1"
                  :key="userId"
                >
                  <v-avatar left>
                    <v-img :src="userPic(userId)"></v-img>
                  </v-avatar>
                  {{ userName(userId) }}
                </v-chip>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <h2 v-else class="mx-auto mt-4 text-center">
          <v-divider class="my-3"></v-divider>
          {{ $t("subgroup.Subgroup.noSubgroups") }}
        </h2>
      </v-card-text>
    </v-card>
    <SubgroupInfo
      :subgroupkey="editSubgroupId"
      :noActivator="true"
      :key="dialogKey"
      @closed="
        editSubgroupId = null;
        dialogKey++;
      "
    />
    <DeleteSubgroup :subgroupkey="deleteSubgroupId" @closed="deleteSubgroupId = null" />
  </v-container>
</template>

<script>
import SubgroupInfo from "./SubgroupInfo";
import DeleteSubgroup from "./DeleteSubgroup";

export default {
  name: "Subgroup",
  components: {
    SubgroupInfo,
    DeleteSubgroup,
  },
  data() {
    return {
      panel: [],
      readonly: true,
      dialogKey: 1,
      editSubgroupId: null,
      deleteSubgroupId: null,
    };
  },
  methods: {
    panelClicked(a) {
      if (this.panel.includes(a)) {
        this.panel.splice(this.panel.indexOf(a), 1);
      } else {
        this.panel.push(a);
      }
    },
    userPic(id) {
      return this.$store.getters.getImageUrlById(id);
    },
    userName(id) {
      return this.$store.getters.getUserById(id).name;
    },
  },
  computed: {
    subgroups() {
      return Object.values(this.$store.state.trip.subgroups);
    },
  },
};
</script>
